
export default function ({ store }) {
  store.app.router.beforeEach((to, from, next) => {
    if(store.getters.isLoggedIn) {
      next();
    } else {
      window.location.replace('/pages/login');
    }
  })
}